<!-- Legend Container -->
<div class="flex align-items-center justify-content-end gap-4">
  <!-- Measured Data Legend Item -->
  <div class="flex align-items-center gap-2">
    <div class="w-1rem h-1rem border-circle" style="background-color: #0dffbf"></div>
    <span class="text-sm text-500">Measured</span>
  </div>

  <!-- Estimated Data Legend Item -->
  <div class="flex align-items-center gap-2">
    <div class="w-1rem h-1rem border-circle" style="background-color: #d60bf4"></div>
    <span class="text-sm text-500">Estimated <br />[using SER & K Values]</span>
  </div>
</div>
<p-chart type="line" [data]="data" [options]="options"></p-chart>
<div class="flex justify-content-end mb-4">
  <p-dropdown
    [options]="eyeSideDropDownChoices"
    [ngModel]="eyeSideSelected"
    (onChange)="onEyeSideChange($event)"
    optionLabel="label"
    placeholder="Select Eye Side">
  </p-dropdown>
</div>
